/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationParametersFromJSON, PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationParametersToJSON, } from './PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationParameters';
/**
 * @export
 */
export const PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationTypeEnum = {
    PaymentGateway: 'PAYMENT_GATEWAY'
};
/**
 * Check if a given object implements the PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecification interface.
 */
export function instanceOfPaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecification(value) {
    if (!('parameters' in value) || value['parameters'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationFromJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationFromJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'parameters': PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationParametersFromJSON(json['parameters']),
        'type': json['type'],
    };
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationToJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationToJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'parameters': PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerTokenizationSpecificationParametersToJSON(value['parameters']),
        'type': value['type'],
    };
}
